import React, { useState, useCallback, useMemo, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Paper,
  Container,
  Chip,
  Divider,
  Avatar,
  IconButton,
  useTheme,
  useMediaQuery,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  alpha,
  Breadcrumbs,
  Link,
  Tooltip,
  CircularProgress
} from "@mui/material";
import {
  LocalOffer as OfferIcon,
  Star as StarIcon,
  EmojiFoodBeverage as FoodIcon,
  Person as PersonIcon,
  LocationOn as LocationIcon,
  AccessTime as TimeIcon,
  Cancel as CancelIcon,
  Bookmark as BookingIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  Home as HomeIcon,
  Restaurant as RestaurantIcon,
  Edit as EditIcon,
  Schedule as ScheduleIcon,
  Lock as LockIcon,
  ArrowBack as ArrowBackIcon,
  Clear as ClearIcon,
  LunchDining as LunchDiningIcon
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { AllCommunityModule, ModuleRegistry, DateFilterModule, TextFilterModule, NumberFilterModule } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import axiosInstance from "../../lib/axios";
import { set } from "lodash";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import BackArrowIcon from '@mui/icons-material/ArrowBack';
import ConfirmationDialog from "../ReusableDailog";

ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule, TextFilterModule, NumberFilterModule]);

const FoodService = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const gridRef = useRef();

  const location = useLocation()
  const currentBooking = location.state?.bookingsData[0]

  const [orders, setOrders] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [isLoading, setIsLoading] = useState(false);
  const [mealTypes, setMealTypes] = useState([]);
  const [instituteLocations, setInstituteLocations] = useState([]);
  const [deliveryLocations, setDeliveryLocations] = useState([]);
  const [cancelTimeRemaining, setCancelTimeRemaining] = useState(null);
  const [canCancel, setCanCancel] = useState(true);
  const [countdownInterval, setCountdownInterval] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [formData, setFormData] = useState({
    MealTypeId: '',
    Req_LockTime: '',
    Req_CanlTime: '',
    InstituteName: currentBooking?.InstituteName || '',
    InstituteId: currentBooking?.InstituteId || '',
    Req_Qty: 1,
    Req_Remark: '',
    Tfn_ReqSt: '',
    Remark: '',
    Dlv_Time: '',
    customDlv_Loc: '',
    OTP: '',
    Tfn_ReqId: '',
    Req_Date: new Date().toISOString().split('T')[0]
  });
  console.log("formData", formData);
  const fetcOrderdata = async () => {
    setIsLoading(true);
    const payload = {
      PropId:currentBooking?.PropId,
      Id: currentBooking?.ResidentId,
      Flag: "Tfn_Resident"
    }
    try {
      const response = await axiosInstance.post('TrnTiffin/RetriveTrnTiffin', payload)
      let ordersData = response.data.Data || [];
      ordersData = ordersData.map(order => ({
        ...order,
        Tfn_ReqId: order.Tfn_ReqId
      }));

      setOrders(ordersData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching tiffin order data:", error);
    }
  }
  const getMelaType = async () => {
    try {
      const response = await axiosInstance.post('MstFood/GetdrpMstMealType', {
        "Flag": "TiffinService"
      });

      setMealTypes(response.data.Data || []);
    } catch (error) {
      console.error("Error fetching meal types:", error);
    }
  }

  const fetchInstituteDetails = async () => {
    try {
      const payload = {
        InstituteId: currentBooking?.InstituteId,
        Flag: "P"
      };

      const response = await axiosInstance.post('MstInstitute/RetriveMstInstituteDtl', payload);

      if (response.data.Status === 0 && response.data.Data) {
        setDeliveryLocations(response.data.Data);
        if (response.data.Data.length > 0 && !formData.Dlv_Loc) {
          setFormData(prev => ({
            ...prev,
            Dlv_Loc: response.data.Data[0]?.Tiffin_Loc || '',
            InstituteName: response.data.Data[0]?.InstituteName || currentBooking?.InstituteName,
            InstituteId: response.data.Data[0]?.InstituteId || currentBooking?.InstituteId
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching institute details:", error);
      toast.error("Failed to load institute details. Please try again later.");
    }
  };

  useEffect(() => {
    fetcOrderdata();
    getMelaType();
    fetchInstituteDetails();
  }, []);
  useEffect(() => {
    if (currentBooking?.InstituteName) {
      setFormData(prev => ({
        ...prev,
        InstituteName: currentBooking.InstituteName,
        InstituteId: currentBooking.InstituteId
      }));
    }
  }, [currentBooking]);

  const StatusChipRenderer = (params) => {
    const status = params.value || 'Unknown';
    const getStatusColor = (status) => {
      switch (status) {
        case 'Booked': return { color: '#4caf50', bgColor: '#e8f5e9' };
        case 'Active': return { color: '#2196f3', bgColor: '#e3f2fd' };
        case 'Pending': return { color: '#ff9800', bgColor: '#fff3e0' };
        case 'On the Way': return { color: '#9c27b0', bgColor: '#f3e5f5' };
        case 'Delivered': return { color: '#ebf5ec', bgColor: '#06620e' };
        case 'Cancelled': return { color: '#f44336', bgColor: '#ffebee' };
        default: return { color: '#757575', bgColor: '#eeeeee' };
      }
    };
    const config = getStatusColor(status);

    return React.createElement('div', {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 9px',
        borderRadius: '16px',
        fontSize: '12px',
        fontWeight: '600',
        color: config.color,
        backgroundColor: config.bgColor,
        border: `1px solid ${config.color}40`,
        whiteSpace: 'nowrap',
        minWidth: '70px',
        boxSizing: 'border-box',
        height: '20px',
        lineHeight: '20px'
      }
    }, status);
  };


  const formatDateOnly = (dateTime) => {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    if (isNaN(date.getTime())) return dateTime;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatTimeOnly = (dateTime) => {
    if (!dateTime) return '';
    if (dateTime.match(/^\d{2}:\d{2}/)) return dateTime.substring(0, 5);
    return new Date(dateTime).toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    });
  };

 const isPastLockTime = (lockTime, orderDate) => {
  if (!lockTime) return false;
  const now = new Date();
  const orderDateTime = new Date(orderDate);
  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);
  const orderDateOnly = new Date(orderDate);
  orderDateOnly.setHours(0, 0, 0, 0);
  if (orderDateOnly > todayDate) {
    return false;
  }

  if (orderDateOnly.getTime() === todayDate.getTime()) {
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const [lockHours, lockMinutes] = lockTime.split(':').map(Number);

    if (currentHours > lockHours) {
      return true;
    } else if (currentHours === lockHours && currentMinutes > lockMinutes) {
      return true;
    }
  }
  
  return false;
};

  const DateCellRenderer = (params) => {
   if (!params.value) return '';
  const date = new Date(params.value);
  if (isNaN(date.getTime())) return params.value;
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

  const mobileColDefs = useMemo(() => [
    {
      field: 'Tfn_ReqId',
      headerName: 'Order No',
      flex: 1,
      minWidth: 70,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      field: 'Req_Date',
      headerName: 'Order Date',
      flex: 1,
      minWidth: 120,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellRenderer: DateCellRenderer, 
    },
    {
      field: 'MealTypeName',
      headerName: 'Meal Type',
      flex: 1,
      minWidth: 90,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },

    {
      field: 'InstituteName',
      headerName: 'Institute Name',
      flex: 1,
      minWidth: 160,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      tooltipValueGetter: (params) => params.value ?? ''
    },
    {
      field: 'Dlv_Loc',
      headerName: 'Delivery Location',
      flex: 1,
      minWidth: 130,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      tooltipValueGetter: (params) => params.value ?? ''
    },
    {
      field: 'Dlv_Time',
      headerName: 'Delivery Time',
      width: 150,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
        cellRenderer: DateCellRenderer, 
    },
    {
      field: 'Req_Qty',
      headerName: 'Qty',
      width: 70,
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      type: 'rightAligned'
    },
    {
      field: 'Tfn_ReqSt',
      headerName: 'Status',
      width: 130,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellRenderer: StatusChipRenderer,

    },
    {
      field: 'Req_Remark',
      headerName: 'Request Rmk',
      width: 150,
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      cellStyle: { textAlign: 'center' },
      cellStyle: { fontWeight: 'bold', color: '#635bff' }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 60,
      sortable: false,
      filter: false,
      floatingFilter: false,
      cellRenderer: (params) => (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {
            params.data.Tfn_ReqSt !== 'Delivered' &&
            params.data.Tfn_ReqId && (
              <Tooltip title="Edit Order" arrow>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    editOrder(params.data.Tfn_ReqId);
                  }}
                  sx={{ color: '#635bff' }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
        </Box>
      )
    }
  ], []);

  const desktopColDefs = useMemo(() => [
    {
      field: 'Tfn_ReqId',
      headerName: 'Order No',
      flex: 1,
      minWidth: 80,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      field: 'Req_Date',
      headerName: 'Order Date & Time',
      flex: 1,
      minWidth: 150,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellRenderer: DateCellRenderer,
    },
    {
      field: 'MealTypeName',
      headerName: 'Meal Type',
      flex: 1,
      minWidth: 110,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },

    {
      field: 'InstituteName',
      headerName: 'Institute Name',
      flex: 1,
      minWidth: 170,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      tooltipValueGetter: (params) => params.value ?? ''
    },
    {
      field: 'Dlv_Loc',
      headerName: 'Delivery Location',
      flex: 1,
      minWidth: 160,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      tooltipValueGetter: (params) => params.value ?? ''
    },
    {
      field: 'Dlv_Time',
      headerName: 'Delivery Time',
      width: 150,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellRenderer: DateCellRenderer,

    },
    {
      field: 'Dlv_OTP',
      headerName: 'OTP',
      width: 110,
      filter: 'agTextColumnFilter',
      floatingFilter: true
    },

    {
      field: 'Req_Qty',
      headerName: 'Qty',
      width: 80,
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      cellStyle: { textAlign: 'center' }
    },
    {
      field: 'Tfn_ReqSt',
      headerName: 'Status',
      width: 130,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      cellRenderer: StatusChipRenderer,
      cellStyle: { textAlign: 'center' }
    },
    {
      field: 'Req_Remark',
      headerName: 'Request Rmk',
      width: 150,
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      type: 'rightAligned',

    },

    {
      field: 'actions',
      headerName: 'Actions',
      width: 60,
      sortable: false,
      filter: false,
      floatingFilter: false,
      cellRenderer: (params) => (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {
            params.data.Tfn_ReqSt !== 'Delivered' &&
            params.data.Tfn_ReqId && (
              <Tooltip title="Edit Order" arrow>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    editOrder(params.data.Tfn_ReqId);
                  }}
                  sx={{ color: '#635bff' }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
        </Box>
      )
    }
  ], []);

  const colDefs = isMobile ? mobileColDefs : desktopColDefs;

  const defaultColDef = useMemo(() => ({
    sortable: true,
    filter: true,
    resizable: true,
    floatingFilter: !isMobile,
    width: 100,
    minWidth: 80,
    tooltipValueGetter: (params) => params.value ?? '',
    wrapHeaderText: true,
    autoHeaderHeight: true,
  }), [isMobile]);

  const getMinDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const handleMealTypeChange = (mealTypeId) => {
    const selectedMeal = mealTypes.find(meal => meal.MealTypeId === mealTypeId);
    if (selectedMeal) {
      const formatLockTime = selectedMeal.Req_LockTime ? selectedMeal.Req_LockTime.substring(0, 5) : '';
      const formatCancelTime = selectedMeal.Req_CanlTime ? selectedMeal.Req_CanlTime.substring(0, 5) : '';
      const calculatedDeliveryTime = addHoursToTime(formatLockTime, 3);
      setFormData(prev => ({
        ...prev,
        MealTypeId: mealTypeId,
        Req_LockTime: formatLockTime,
        Req_CanlTime: formatCancelTime,
        Dlv_Time: calculatedDeliveryTime || prev.Dlv_Time
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        MealTypeId: mealTypeId,
        Req_LockTime: '',
        Req_CanlTime: ''
      }));
    }
  };

  const handleInputChange = (field, value) => {
    console.log(`Changing ${field} to:`, value);
    setFormData(prev => ({ ...prev, [field]: value }));
  };



  const generateBookingNo = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    return `TIF-${year}${month}${day}-${random}`;
  };

  const handleSubmitOrder = async () => {

    if (formData.Req_LockTime && isPastLockTime(formData.Req_LockTime)) {
      toast.error(`Cannot place order! The lock time (${formData.Req_LockTime}) has passed. Please try again tomorrow.`);
      return;
    }

    if (!formData.MealTypeId || !formData.Req_LockTime || !formData.Req_CanlTime ||
      !formData.Dlv_Loc || !formData.Req_Qty || !formData.Req_Date) {
      toast.error('Please fill in all required fields ');
      return;
    }

    setIsLoading(true);

    const currentDateTime = new Date();
    const formattedDateTime = `${formData.Req_Date} ${currentDateTime.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })}`;

    const payload = {
      Req_Date: formattedDateTime,
      Req_RaisedId: 1,
      MealTypeId: formData.MealTypeId,
      Req_LockTime: formData.Req_LockTime,
      Req_CanlTime: formData.Req_CanlTime,
      PropId: currentBooking?.PropId,
      BookId: currentBooking?.BookId,
      ResidentId: currentBooking?.ResidentId,
      InstituteId: currentBooking?.InstituteId,
      Dlv_Time: formData.Dlv_Time,
      Dlv_Loc: formData.Dlv_Loc,
      Req_Qty: formData.Req_Qty,
      Req_Remark: formData.Req_Remark || '',
      Tfn_ReqSt: "Booked",
      Remark: formData.Remark || '',
      Status: "1",
      CreatedBy: currentBooking?.ResidentId,
    };

    try {
      const response = await axiosInstance.post('TrnTiffin/InsertTrnTiffin', payload);

      if (response.data.Status === 0) {
        toast.success('Tiffin booked successfully!');
        setOpenDialog(false);
        resetForm();
        fetcOrderdata();
      } else {
        toast.error(response.data.Message || 'Failed to book tiffin');
      }
    } catch (error) {
      console.error("Error booking tiffin:", error);
      toast.error('Error booking tiffin. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      MealTypeId: '',
      Req_LockTime: '',
      Req_CanlTime: '',
      Dlv_Loc: '',
      Req_Qty: 1,
      Req_Remark: '',
      Tfn_ReqSt: 'Pending',
      Remark: '',
      Dlv_Time: '',
      customDlv_Loc: '',
      Req_Date: new Date().toISOString().split('T')[0]
    });
    setEditMode(false);
    setCurrentOrderId(null);
  };

  const cancelOrder = (orderId) => {
    const updatedOrders = orders.map(order =>
      order.Tfn_ReqId === orderId ? { ...order, status: 'Cancelled' } : order
    );
    setOrders(updatedOrders);
    setSnackbar({ open: true, message: 'Order cancelled successfully!', severity: 'info' });
  };

  const deleteOrder = (orderId) => {
    setOrders(orders.filter(order => order.Tfn_ReqId !== orderId));
    setSnackbar({ open: true, message: 'Order removed!', severity: 'warning' });
  };

  const fetchSingleOrder = async (tfnReqId) => {
    const payload = {
      Id: tfnReqId,
      Flag: "R"
    };

    try {
      const response = await axiosInstance.post('TrnTiffin/RetriveTrnTiffin', payload);
      if (response.data.Status === 0 && response.data.Data && response.data.Data.length > 0) {
        return response.data.Data[0];
      }
      return null;
    } catch (error) {
      console.error("Error fetching single order:", error);
      return null;
    } finally {

    }
  };


  const editOrder = async (orderId) => {
    const orderToEdit = await fetchSingleOrder(orderId);
    if (orderToEdit) {
      setEditMode(true);
      setCurrentOrderId(orderToEdit.Tfn_ReqId);

      const formatTime = (dateTime) => {
        if (!dateTime) return '';
        if (typeof dateTime === 'string' && dateTime.match(/^\d{2}:\d{2}/)) {
          return dateTime.substring(0, 5);
        }
        try {
          const date = new Date(dateTime);
          if (!isNaN(date.getTime())) {
            return date.toLocaleTimeString('en-US', {
              hour12: false,
              hour: '2-digit',
              minute: '2-digit'
            });
          }
          return dateTime;
        } catch (error) {
          return dateTime;
        }
      };

      setFormData({
        MealTypeId: orderToEdit.MealTypeId || '',
        Req_LockTime: formatTime(orderToEdit.Req_LockTime),
        Req_CanlTime: formatTime(orderToEdit.Req_CanlTime),
        InstituteName: currentBooking?.InstituteName || orderToEdit.InstituteName || '',
        InstituteId: currentBooking?.InstituteId || orderToEdit.InstituteId || '',
        Req_Qty: orderToEdit.Req_Qty || 1,
        Req_Remark: orderToEdit.Req_Remark || '',
        Tfn_ReqSt: orderToEdit.Tfn_ReqSt || '',
        Remark: orderToEdit.Remark || '',
        Dlv_Time: formatTime(orderToEdit.Dlv_Time),
        Dlv_Loc: orderToEdit.Dlv_Loc || '',
        customDlv_Loc: '',
        OTP: orderToEdit.Dlv_OTP || '',
        Tfn_ReqId: orderToEdit.Tfn_ReqId,
        Req_Date: orderToEdit.Req_Date ? orderToEdit.Req_Date.split('T')[0] : new Date().toISOString().split('T')[0]
      });
      setOpenDialog(true);
    } else {
      console.error("Order not found:", orderId);
      toast.error('Order not found. Please try again.');
    }
  };
  const handleUpdateOrder = async () => {
    if (!formData.MealTypeId || !formData.Req_LockTime || !formData.Req_CanlTime ||
      !formData.Dlv_Loc || !formData.Req_Qty) {
      toast.error('Please fill all required fields!');
      return;
    }

    setIsLoading(true);
    const formatTimeForAPI = (time) => {
      if (!time) return '';
      if (time.includes(':')) {
        const parts = time.split(':');
        if (parts.length === 2) {
          return `${parts[0]}:${parts[1]}:00`;
        }
      }
      return time;
    };
    const currentDateTime = new Date();
    const formattedDateTime = `${formData.Req_Date} ${currentDateTime.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })}`;
    const payload = {
      Tfn_ReqId: currentOrderId,
      Req_Date: formattedDateTime,
      Req_RaisedId: 1,
      MealTypeId: formData.MealTypeId,
      Req_LockTime: formatTimeForAPI(formData.Req_LockTime),
      Req_CanlTime: formatTimeForAPI(formData.Req_CanlTime),
      PropId: currentBooking?.PropId,
      BookId: currentBooking?.BookId,
      ResidentId: currentBooking?.ResidentId,
      InstituteId: currentBooking?.InstituteId,
      Dlv_Time: formatTimeForAPI(formData.Dlv_Time),
      Dlv_Loc: formData.Dlv_Loc,
      Req_Qty: formData.Req_Qty,
      Req_Remark: formData.Req_Remark || '',
      Tfn_ReqSt: editMode ? 'Booked' : formData.Tfn_ReqSt,
      Remark: formData.Remark || '',
      Status: editMode ? "1" : "0",
      UpdatedBy: currentBooking?.ResidentId
    };

    try {
      const response = await axiosInstance.post('TrnTiffin/UpdateTrnTiffin', payload);

      if (response.data.Status === 0) {
        toast.success('Tiffin order updated successfully!');
        setOpenDialog(false);
        resetForm();
        fetcOrderdata();
      } else {
        toast.error(response.data.Message || 'Failed to update tiffin order');
      }
    } catch (error) {
      console.error("Error updating tiffin:", error);
      toast.error('Error updating tiffin. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = () => {
    return formData.MealTypeId &&
      formData.Req_LockTime &&
      formData.Req_CanlTime &&
      (formData.Dlv_Loc || formData.customDlv_Loc) &&
      formData.Req_Qty > 0;
  };

  const onGridReady = useCallback((params) => {
    if (isMobile) {
      setTimeout(() => {
        params.api.sizeColumnsToFit();
      }, 100);
    }
  }, [isMobile]);

  const onGridSizeChanged = useCallback((params) => {
    if (isMobile) {
      params.api.sizeColumnsToFit();
    }
  }, [isMobile]);

  const handleClearFilters = () => {
    gridRef.current?.api?.setFilterModel(null);
  };

  const handleRowDoubleClick = useCallback((params) => {
    if (params.data && params.data.Tfn_ReqId) {
      editOrder(params.data.Tfn_ReqId);
    }
  }, []);

  const handleBackClick = () => {
    navigate('/residentmenu');
  }
  const handleCancelTiffin = async (orderId) => {
    const orderToCancel = orders.find(order => order.Tfn_ReqId === currentOrderId);
  if (!orderToCancel) {
    toast.error('Order not found');
    return;
  }
  

  const orderDate = new Date(orderToCancel.Req_Date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  orderDate.setHours(0, 0, 0, 0);

  if (orderDate < today) {
    toast.error('Cannot cancel orders from past dates');
    return;
  }

  if (orderDate.getTime() === today.getTime() && formData.Req_CanlTime) {
    if (isCancelTimePassed(formData.Req_CanlTime, orderToCancel.Req_Date)) {
      toast.error(`Cannot cancel order! The cancellation time (${formData.Req_CanlTime}) has passed for today's order.`);
      return;
    }
  }
    setIsLoading(true);
    const formatTimeForAPI = (time) => {
      if (!time) return '';
      if (time.includes(':')) {
        const parts = time.split(':');
        if (parts.length === 2) {
          return `${parts[0]}:${parts[1]}:00`;
        }
      }
      return time;
    };

    const currentDateTime = new Date();
    const formattedDateTime = `${formData.Req_Date} ${currentDateTime.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })}`;

    const payload = {
      Tfn_ReqId: currentOrderId,
      Req_Date: formattedDateTime,
      Req_RaisedId: 1,
      MealTypeId: formData.MealTypeId,
      Req_LockTime: formatTimeForAPI(formData.Req_LockTime),
      Req_CanlTime: formatTimeForAPI(formData.Req_CanlTime),
      PropId: currentBooking?.PropId,
      BookId: currentBooking?.BookId,
      ResidentId: currentBooking?.ResidentId,
      InstituteId: currentBooking?.InstituteId,
      Dlv_Time: formatTimeForAPI(formData.Dlv_Time),
      Dlv_Loc: formData.Dlv_Loc,
      Req_Qty: formData.Req_Qty,
      Req_Remark: formData.Req_Remark || '',
      Tfn_ReqSt: "Cancelled",
      Remark: formData.Remark || '',
      Status: "0",
      UpdatedBy: currentBooking?.ResidentId
    };

    try {
      const response = await axiosInstance.post('TrnTiffin/UpdateTrnTiffin', payload);
      if (response.data.Status === 0) {
        toast.success(response.data.Message || 'Tiffin order cancelled successfully!');
        setOpenDialog(false);
        setConfirmDialogOpen(false);
        resetForm();
        fetcOrderdata();
      } else {
        toast.error(response.data.Message || 'Failed to update tiffin order');
      }
    } catch (error) {
      console.error("Error updating tiffin:", error);
      toast.error('Error updating tiffin. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const calculateTimeRemaining = (cancelTime, orderDate) => {
  if (!cancelTime) return null;

  const now = new Date();
  const orderDateTime = new Date(orderDate);
  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);
  const orderDateOnly = new Date(orderDate);
  orderDateOnly.setHours(0, 0, 0, 0);
  
  if (orderDateOnly > todayDate) {
    const cancelDateTime = new Date(orderDate);
    const [hours, minutes] = cancelTime.split(':').map(Number);
    cancelDateTime.setHours(hours, minutes, 0, 0);
    
    const timeDiff = cancelDateTime - now;
    
    if (timeDiff <= 0) {
      return { total: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    
    const totalSeconds = Math.floor(timeDiff / 1000);
    const hoursLeft = Math.floor(totalSeconds / 3600);
    const minutesLeft = Math.floor((totalSeconds % 3600) / 60);
    const secondsLeft = totalSeconds % 60;
    
    return {
      total: timeDiff,
      hours: hoursLeft,
      minutes: minutesLeft,
      seconds: secondsLeft
    };
  }

  if (orderDateOnly.getTime() === todayDate.getTime()) {
    const [hours, minutes] = cancelTime.split(':').map(Number);
    
    const cancelDateTime = new Date();
    cancelDateTime.setHours(hours, minutes, 0, 0);
    
    if (cancelDateTime < now) {
      return { total: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    
    const timeDiff = cancelDateTime - now;
    const totalSeconds = Math.floor(timeDiff / 1000);
    const hoursLeft = Math.floor(totalSeconds / 3600);
    const minutesLeft = Math.floor((totalSeconds % 3600) / 60);
    const secondsLeft = totalSeconds % 60;
    
    return {
      total: timeDiff,
      hours: hoursLeft,
      minutes: minutesLeft,
      seconds: secondsLeft
    };
  }
 
  return { total: 0, hours: 0, minutes: 0, seconds: 0 };
};

  const formatCountdownDisplay = (timeRemaining) => {
    if (!timeRemaining) return '';
    if (timeRemaining.total <= 0) return 'Expired';

    if (timeRemaining.hours > 0) {
      return `${timeRemaining.hours}h ${timeRemaining.minutes}m ${timeRemaining.seconds}s`;
    } else if (timeRemaining.minutes > 0) {
      return `${timeRemaining.minutes}m ${timeRemaining.seconds}s`;
    } else {
      return `${timeRemaining.seconds}s`;
    }
  };

 useEffect(() => {
  if (openDialog && editMode && currentOrderId && formData.Req_CanlTime) {
    const orderToCheck = orders.find(order => order.Tfn_ReqId === currentOrderId);
    if (!orderToCheck) return;
    
    if (countdownInterval) {
      clearInterval(countdownInterval);
    }
    
    const initialTime = calculateTimeRemaining(formData.Req_CanlTime, orderToCheck.Req_Date);
    setCancelTimeRemaining(initialTime);
    setCanCancel(initialTime && initialTime.total > 0);
    
    const interval = setInterval(() => {
      const timeRemaining = calculateTimeRemaining(formData.Req_CanlTime, orderToCheck.Req_Date);
      setCancelTimeRemaining(timeRemaining);
      setCanCancel(timeRemaining && timeRemaining.total > 0);
      
      if (timeRemaining && timeRemaining.total <= 0) {
        clearInterval(interval);
      }
    }, 1000);
    
    setCountdownInterval(interval);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  } else if (!openDialog && countdownInterval) {
    clearInterval(countdownInterval);
    setCountdownInterval(null);
    setCancelTimeRemaining(null);
  }
}, [openDialog, editMode, formData.Req_CanlTime, currentOrderId, orders]);

  const addHoursToTime = (timeStr, hoursToAdd) => {
  if (!timeStr) return '';
  const [hours, minutes] = timeStr.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  date.setHours(date.getHours() + hoursToAdd);
  const newHours = String(date.getHours()).padStart(2, '0');
  const newMinutes = String(date.getMinutes()).padStart(2, '0');
  return `${newHours}:${newMinutes}`;
};
const isCancelTimePassed = (cancelTime, orderDate) => {
  if (!cancelTime) return true;
  
  const now = new Date();
  const orderDateTime = new Date(orderDate);
  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);
  const orderDateOnly = new Date(orderDate);
  orderDateOnly.setHours(0, 0, 0, 0);
  if (orderDateOnly > todayDate) {
    return false;
  }
  
  if (orderDateOnly.getTime() === todayDate.getTime()) {
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const [cancelHours, cancelMinutes] = cancelTime.split(':').map(Number);
    
    if (currentHours > cancelHours) {
      return true;
    } else if (currentHours === cancelHours && currentMinutes > cancelMinutes) {
      return true;
    }
    return false;
  }
  
  return true;
};
const canCancelOrder = useMemo(() => {
  if (!currentOrderId) return false;
  
  const orderToCheck = orders.find(order => order.Tfn_ReqId === currentOrderId);
  if (!orderToCheck) return false;

  if (orderToCheck.Tfn_ReqSt === 'Cancelled' || orderToCheck.Tfn_ReqSt === 'Delivered') {
    return false;
  }
  
  const orderDate = new Date(orderToCheck.Req_Date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  orderDate.setHours(0, 0, 0, 0);
  
  if (orderDate < today) {
    return false;
  }

  if (formData.Req_CanlTime) {
    return !isCancelTimePassed(formData.Req_CanlTime, orderToCheck.Req_Date);
  }
  
  return true;
}, [formData.Req_CanlTime, currentOrderId, orders]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '90vh',
        mt: 2,
        padding: { xs: '5px', sm: '10px' },
        backgroundColor: 'rgb(249, 249, 249)',
        position: 'relative'
      }}
    >
      <ToastContainer />

      <Box
        sx={{
          backgroundColor: "#ffffff",
          padding: { xs: "10px 10px", sm: "14px 18px" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          borderRadius: "12px",
          margin: { xs: "5px auto", sm: "10px auto" },
          maxWidth: "100%",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
        }}
      >
        {/* LEFT SECTION */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <BackArrowIcon sx={{ cursor: 'pointer', fontSize: { xs: 14, sm: 24 } }} onClick={handleBackClick} />
          <Avatar sx={{ bgcolor: "#635bff", width: 30, height: 30 }}>
            {currentBooking?.FirstName?.charAt(0)}
          </Avatar>

          <Box>
            <Typography variant="caption" color="text.secondary">
              <span style={{ fontWeight: "bold" }}>Booking No : </span> {currentBooking?.BookNo}
            </Typography>

            <Typography variant="body2" fontWeight="bold">
              <span style={{ fontWeight: "bold" }}>Resident Name : </span> {[currentBooking?.FirstName, currentBooking?.LastName]
                .filter(Boolean)
                .join(" ")}
            </Typography>

            <Typography variant="body2">
              <span style={{ fontWeight: "bold" }}>Property: </span>
              {currentBooking?.PropName}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            textAlign: { xs: "left", md: "right" },
            width: "100%",
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{ fontWeight: "bold" }}
          >
            <LunchDiningIcon
              sx={{
                verticalAlign: "middle",
                mr: 1,
                fontSize: { xs: 18, sm: 20, md: 26 },
              }}
            />
            Tiffin Service
          </Typography>

          <Typography variant={isMobile ? "body2" : "body1"}>
            Fresh, homemade meals delivered to your preferred location
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          mb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
          maxWidth: '97%',
          margin: '0 auto 16px auto'
        }}
      >
        <Typography variant="h5" fontWeight="bold">My Tiffin Orders</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title='Clear all applied filters' arrow>
            <Button
              variant="outlined"
              onClick={handleClearFilters}
              size="small"
              sx={{
                borderRadius: "50px",
                textTransform: "none",
                borderColor: "#635bff",
                color: "#635bff",
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                "&:hover": {
                  borderColor: "#524ccc",
                  backgroundColor: "rgba(99, 91, 255, 0.04)",
                }
              }}
            >
              {isMobile ? 'Clear' : 'Clear Filters'}
            </Button>
          </Tooltip>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              resetForm();
              setOpenDialog(true);
            }}
            sx={{
              borderRadius: "50px",
              background: "#635bff",
              textTransform: "none",
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            }}
            size={isMobile ? "small" : "medium"}

          >
            Order Tiffin
          </Button>
        </Box>
      </Box>

      {orders.length === 0 ? (
        <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 3, maxWidth: '95%', margin: '0 auto' }}>
          <FoodIcon sx={{ fontSize: 80, color: '#ccc', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">No tiffin bookings yet</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Click the "Order Tiffin" button to place your first order
          </Typography>
          <Button variant="outlined" onClick={() => setOpenDialog(true)}>
            Order Now
          </Button>
        </Paper>
      ) : (
        <Box
          className={`table-grid ag-theme-alpine ${isMobile ? 'ag-grid-mobile' : ''}`}
          sx={{
            height: { xs: 'calc(97% - 180px)', sm: 'calc(97% - 180px)' },
            width: '100%',
            margin: '0 auto',
            position: 'relative',
            '&.ag-grid-mobile .ag-cell': {
              fontSize: '12px',
              padding: '0 4px',
            },
            '&.ag-grid-mobile .ag-header-cell-text': {
              fontSize: '11px',
              fontWeight: 'bold',
            },
            '& .ag-theme-alpine': {
              '--ag-header-background-color': '#635bff',
              '--ag-header-foreground-color': 'white',
              '--ag-header-font-weight': 'bold',
              borderRadius: '12px'
            }
          }}
        >
          {isLoading ? (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 10,
                textAlign: 'center',
              }}
            >
              <CircularProgress size="3rem" sx={{ color: '#635bff' }} />
              <Typography sx={{
                marginTop: 2,
                color: '#635bff',
                fontWeight: 'bold',
                fontSize: { xs: '0.875rem', sm: '1rem' }
              }}>
                Loading data...
              </Typography>
            </Box>
          ) : (
            <AgGridReact
              ref={gridRef}
              rowData={orders}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              pagination={true}
              paginationPageSize={isMobile ? 10 : 100}
              onRowDoubleClicked={handleRowDoubleClick}
              paginationPageSizeSelector={isMobile ? [10, 20, 50] : [50, 100, 200]}
              onGridReady={onGridReady}
              onGridSizeChanged={onGridSizeChanged}
              enableCellTextSelection={true}
              rowHeight={isMobile ? 25 : 28}
              headerHeight={isMobile ? 28 : 30}
              floatingFiltersHeight={isMobile ? 28 : 32}
              suppressHorizontalScroll={isMobile ? true : false}
              domLayout={isMobile ? "autoHeight" : "normal"}
              overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No tiffin orders found</span>'}
              tooltipShowDelay={0}
              suppressColumnVirtualisation={isMobile}
              animateRows={true}
            />
          )}
        </Box>
      )}

      <Box
        sx={{
          position: 'absolute',
              bottom: { xs: 10, sm: 40 },  
          left: { xs: 10, sm: 20 }, 
          fontSize: { xs: '12px', sm: '14px' },
          color: 'black',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: { xs: '2px 6px', sm: '4px 12px' },
          borderRadius: '4px',
        }}
      >
        Total Records: <b>{orders.length}</b>
      </Box>


      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          resetForm();
        }}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle sx={{ pb: 1, pt: 1 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            <LunchDiningIcon sx={{ verticalAlign: 'middle', mr: 1, color: '#635bff' }} />
            {editMode ? 'Edit Tiffin Order' : 'Book Your Tiffin'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Fill in the details below to {editMode ? 'update your' : 'place your'} tiffin order
          </Typography>
        </DialogTitle>

        <DialogContent dividers sx={{ py: 1, px: 2 }}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: 1.5, bgcolor: alpha('#635bff', 0.05), borderRadius: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2" color="#635bff" gutterBottom>
                        <PersonIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                        Ordering for:
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        <span style={{ fontWeight: 'bold', color: '#635bff' }}>Booking No :</span> {currentBooking?.BookNo}
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        <span style={{ fontWeight: 'bold', color: '#635bff' }}>Name :</span> {`${currentBooking?.FirstName || ''} ${currentBooking?.LastName || ''}`}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2" color="#635bff" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                        <LocationIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                        Location Details:
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>

                        <Typography variant="body2">
                          <span style={{ fontWeight: 600, color: '#635bff' }}>Institute:</span>{' '}
                          {currentBooking?.InstituteName || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                          <span style={{ fontWeight: 600, color: '#635bff' }}>Property :</span>{' '}
                          {currentBooking?.PropName || 'N/A'}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{
                    fontSize: {
                      xs: '0.7rem',
                      sm: '0.9rem',
                      md: '1.1rem',
                    }, display: 'flex', alignItems: 'center'
                  }}>
                    <RestaurantIcon sx={{ mr: 1, color: '#ff9800' }} />
                    Meal Details
                  </Typography>
                  {editMode && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      {cancelTimeRemaining && cancelTimeRemaining.total > 0 && (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            backgroundColor: canCancel ? alpha('#ff9800', 0.1) : alpha('#f44336', 0.1),
                            padding: {
                              xs: '2px 8px',
                              sm: '4px 12px',
                            },
                            borderRadius: '20px',
                            border: `1px solid ${canCancel ? '#ff9800' : '#f44336'}`,
                          }}
                        >
                          <ScheduleIcon sx={{ color: canCancel ? '#ff9800' : '#f44336', fontSize: 16 }} />
                          <Typography variant="caption" sx={{ fontWeight: 'bold', color: canCancel ? '#ff9800' : '#f44336' }}>
                            Cancel within: {formatCountdownDisplay(cancelTimeRemaining)}
                          </Typography>
                        </Box>
                      )}
                      <Button
                        // onClick={handleCancelTiffin}
                        onClick={() => setConfirmDialogOpen(true)}
                        disabled={!canCancel || !canCancelOrder || isLoading || formData.Tfn_ReqSt === 'Cancelled' || formData.Tfn_ReqSt === 'Delivered'}
                        size="small"
                        variant="contained"
                        color="error"
                        sx={{
                          opacity: !canCancel ? 0.6 : 1,
                        }}
                      >
                        Cancel Order
                      </Button>
                    </Box>
                  )}

                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth required variant="filled" className="custom-textfield">
                  <InputLabel>Meal Type</InputLabel>
                  <Select
                    value={formData.MealTypeId}
                    onChange={(e) => handleMealTypeChange(e.target.value)}
                    label="Meal Type"
                  >
                    <MenuItem value="">Select Meal Type</MenuItem>
                    {mealTypes.map((meal) => (
                      <MenuItem key={meal.MealTypeId} value={meal.MealTypeId}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                          <span>{meal.MealTypeName}</span>

                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  required
                  label="Lock Time"
                  type="time"
                  variant="filled"
                  className="custom-textfield"
                  value={formData.Req_LockTime}
                  onChange={(e) => handleInputChange('Req_LockTime', e.target.value)}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  required
                  label="Cancel Time"
                  variant="filled"
                  className="custom-textfield"
                  type="time"
                  value={formData.Req_CanlTime}
                  onChange={(e) => handleInputChange('Req_CanlTime', e.target.value)}
                  disabled
                />
              </Grid>

              <Grid item xs={12} >
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
                  <ScheduleIcon sx={{ mr: 1, color: '#2196f3' }} />
                  Time Settings
                </Typography>
              </Grid>
              {editMode && (
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: alpha('#4caf50', 0.08), borderRadius: 2, }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <LockIcon sx={{ mr: 1, color: '#4caf50' }} />
                      Order Information
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="OTP"
                          type="text"
                          variant="filled"
                          className="custom-textfield"
                          value={formData.OTP || ''}
                          disabled
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            '& .MuiFilledInput-root': {
                              backgroundColor: '#e8f5e9',
                              '&:hover': {
                                backgroundColor: '#e8f5e9',
                              },
                              '&.Mui-disabled': {
                                backgroundColor: '#e8f5e9',
                                opacity: 1,
                              },
                            },
                            '& .MuiFilledInput-input.Mui-disabled': {
                              WebkitTextFillColor: '#2e7d32',
                              opacity: 1,
                              fontWeight: 'bold',
                            },
                            '& .MuiFormLabel-root.Mui-disabled': {
                              color: '#2e7d32',
                              fontWeight: 'bold',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Order No."
                          type="text"
                          variant="filled"
                          className="custom-textfield"
                          value={formData.Tfn_ReqId || ''}
                          disabled
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            '& .MuiFilledInput-root': {
                              backgroundColor: '#e8f5e9',
                              '&:hover': {
                                backgroundColor: '#e8f5e9',
                              },
                              '&.Mui-disabled': {
                                backgroundColor: '#e8f5e9',
                                opacity: 1,
                              },
                            },
                            '& .MuiFilledInput-input.Mui-disabled': {
                              WebkitTextFillColor: '#2e7d32',
                              opacity: 1,
                              fontWeight: 'bold',
                            },
                            '& .MuiFormLabel-root.Mui-disabled': {
                              color: '#2e7d32',
                              fontWeight: 'bold',
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              )}

              <Grid item xs={12} sm={4}>

                <TextField
                  type="date"
                  label="Request Date"
                  variant="filled"
                  className="custom-textfield"
                  value={formData.Req_Date}
                  onChange={(e) => handleInputChange('Req_Date', e.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: getMinDate()
                  }}
                />

              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  required
                  label="Delivery Time"
                  type="time"
                  variant="filled"
                  className="custom-textfield"
                  value={formData.Dlv_Time}
                  onChange={(e) => handleInputChange('Dlv_Time', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  required
                  type="number"
                  variant="filled"
                  className="custom-textfield"
                  label="Quantity"
                  value={formData.Req_Qty}
                  disabled
                  onChange={(e) => handleInputChange('Req_Qty', parseInt(e.target.value) || 1)}
                  inputProps={{ min: 1, max: 10 }}
                  InputLabelProps={{
                    style: {
                      color: 'green',
                      fontWeight: 'bold',
                    },
                  }}
                  sx={{
                    '& .MuiInputBase-input.Mui-disabled': {
                      WebkitTextFillColor: 'green',
                      fontWeight: 'bold',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
                  <LocationIcon sx={{ mr: 1, color: '#635bff' }} />
                  Delivery Location
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth required variant="filled" className="custom-textfield">
                  <InputLabel>Institute Name</InputLabel>
                  <Select
                    value={currentBooking?.InstituteName || ''}
                    onChange={(e) => handleInputChange('InstituteName', e.target.value)}
                    label="Institute Name"
                    disabled
                  >
                    <MenuItem key={currentBooking.InstituteId} value={currentBooking.InstituteName}>
                      {currentBooking.InstituteName}
                    </MenuItem>

                  </Select>

                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth required variant="filled" className="custom-textfield">
                  <InputLabel> Location</InputLabel>
                  <Select
                    value={formData.Dlv_Loc}
                    onChange={(e) => handleInputChange('Dlv_Loc', e.target.value)}
                    label="Delivery Location"
                  >
                    <MenuItem value="">Select Delivery Location</MenuItem>
                    {deliveryLocations?.map(loc => (
                      <MenuItem key={loc.Tiffin_Loc} value={loc.Tiffin_Loc}>
                        {loc.Tiffin_Loc}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </Grid>

              <Grid item xs={12} sx={{ py: 0, my: 0 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    m: 0,
                    py: 0,
                    lineHeight: 1
                  }}
                >
                  <EditIcon sx={{ mr: 1, color: '#ff9800', fontSize: 20 }} />
                  Additional Information
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="filled"
                  className="custom-textfield"
                  fullWidth
                  label="Request Remark"
                  value={formData.Req_Remark}
                  onChange={(e) => handleInputChange('Req_Remark', e.target.value)}
                  multiline
                  rows={1.5}
                  placeholder="Any special requests? (e.g., Extra cheese, Less oil, No onion-garlic)"
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 2, py: 1, gap: 1 }}>
          <Button
            onClick={() => {
              setOpenDialog(false);
              resetForm();
            }}
            variant="outlined"
            sx={{ borderRadius: "50px", textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={editMode ? handleUpdateOrder : handleSubmitOrder}
            disabled={!isFormValid() || isLoading}
            sx={{
              minWidth: 150,
              px: 4,
              borderRadius: "50px",
              background: "#635bff",
              textTransform: "none",
              '&:hover': {
                background: "#524ccc"
              }
            }}
            color={editMode ? "warning" : "primary"}
          >
            {isLoading ? <CircularProgress size={24} /> : (editMode ? 'Update Order' : 'Book Tiffin')}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={confirmDialogOpen}
        title="Confirm Cancellation"
        message="Are you sure you want to cancel this tiffin order?"
        onClose={() => setConfirmDialogOpen(false)}
        onConfirm={handleCancelTiffin}

      />

    </Box>
  );
};

export default FoodService;